import * as firebase from "firebase";
const db = firebase.initializeApp({
    apiKey: "AIzaSyCCasQxBoLwDZSKRqYT4GL7QCkIHTi8xtM",
    authDomain: "libwalk-721c2.firebaseapp.com",
    databaseURL: "https://libwalk-721c2.firebaseio.com",
    projectId: "libwalk-721c2",
    storageBucket: "libwalk-721c2.appspot.com",
    messagingSenderId: "643234122966",
    appId: "1:643234122966:web:c8fde76f57972e65af8d77",
    measurementId: "G-QB8877TYNB"
});

export default db;
